export default "__VITE_PUBLIC_ASSET__c123f175__"